import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/programs')({
	component: RouteComponent,
});

function RouteComponent() {
	return <div>Hello &quot;/programs&quot;!</div>;
}
